import Castilo1 from './Castilo (1).webp'
import Castilo2 from './Castilo (2).webp'
import Castilo3 from './Castilo (3).webp'
import Castilo4 from './Castilo (4).webp'
import Castilo5 from './Castilo (5).webp'
import Castilo6 from './Castilo (6).webp'
import Castilo7 from './Castilo (7).webp'
import Castilo8 from './Castilo (8).webp'
import Castilo9 from './Castilo (9).webp'
import Castilo10 from './Castilo (10).webp'
import Castilo11 from './Castilo (11).webp'


const Castiloimages =[ Castilo1,Castilo2,Castilo3,Castilo4,Castilo5,Castilo6,Castilo7,Castilo8,Castilo9,Castilo10,Castilo11
]

export default Castiloimages;